import type { FC } from 'react';
import React, { useCallback } from 'react';
import T from 'i18n-react';

import { triggerCheckboxGroupFilterSetEvent } from 'Services/analytics/events';
import { useFilters, useSetFilter } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

import { RadioGroupFilterView } from '../RadioGroupFilter';

import {
	getSelectedOption,
	PREVIOUS_OWNERS_FILTER_NAME,
	PREVIOUS_OWNERS_OPTIONS,
	PREVIOUS_OWNERS_SECTION,
} from './PreviousOwnersFilter.consts';

// eslint-disable-next-line @typescript-eslint/no-var-requires
T.setTexts(require('Components/texts.json'));

const PreviousOwnersFilter: FC = () => {
	const filters = useFilters();
	const setFilter = useSetFilter();

	const selectedOption = getSelectedOption(filters.previousKeepersCountFrom, filters.previousKeepersCountTo);

	const handleChange = useCallback(
		(value: string) => {
			const option = PREVIOUS_OWNERS_OPTIONS.find((opt) => opt.value === value);

			if (!option) return;

			setFilter({ id: 'previousKeepersCountFrom', value: option.from });
			setFilter({ id: 'previousKeepersCountTo', value: option.to });

			triggerCheckboxGroupFilterSetEvent({
				clickedOption: option.label,
				section: PREVIOUS_OWNERS_SECTION,
				value: true,
			});
		},
		[setFilter],
	);

	return (
		<RadioGroupFilterView
			id={PREVIOUS_OWNERS_FILTER_NAME}
			isDirty={selectedOption.value !== 'any'}
			name={PREVIOUS_OWNERS_FILTER_NAME}
			onChange={handleChange}
			options={PREVIOUS_OWNERS_OPTIONS}
			title={T.translate('vehicleList.filters.previousKeepers')}
			value={selectedOption.value}
		/>
	);
};

export default PreviousOwnersFilter;
